import PropTypes from 'prop-types';
import './styles.scss';

const RadioButton = ({
  value,
  label,
  options,
  onChange,
  required,
  className = '',
  disabled = false,
}) => {
  const handleOnChange = (v) => {
    if (!disabled) {
      onChange(v);
    }
  };

  return (
    <div className={`ui-radio-button ${className}`}>
      {label && (
        <label className='mb-1'>
          {label}
          {required && '*'}
        </label>
      )}
      <div>
        {options.map((option) => (
          <div className='mb-2 flex items-center' key={option.value}>
            <input
              id={`option-${option.value}`}
              type='radio'
              value={option.value}
              checked={option.value === value}
              disabled={disabled}
              onChange={() => handleOnChange(option.value)}
            />
            <label htmlFor={`option-${option.value}`} className='ml-2 inline-block'>{option.label}</label>
          </div>
        ))}
      </div>
    </div>
  );
};

RadioButton.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  label: PropTypes.string,
  required: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default RadioButton;
